import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Plan interval switch: the monthly segment's label.
export default class MonthlyText extends BaseOption {
  static userInterfaceComponent = {
    label: "Monthly Label",
    component: inspectorTools.SIMPLE_INPUT,
  };

  static defaultValue = "Monthly";
}
